import { ListingSellerDraftModel } from '@steelbuy/ts-shared';

import { ListingSellerDraftCollectionData } from './ListingSellerDraftCollectionData';
import { useCollectionData } from '../../util/consumer/CollectionConsumerHook';

export const useListingSellerDraftCollectionData = () =>
    useCollectionData<ListingSellerDraftModel>(ListingSellerDraftCollectionData);
